"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const recoil_1 = require("recoil");
const ReportViewToggle_1 = require("../shared/ReportViewToggle");
const ReportsTileView_1 = __importDefault(require("../ReportTiles/ReportsTileView"));
const EmptyFolderState_1 = __importDefault(require("../EmptyState/EmptyFolderState"));
const SubFolderTileView = ({ folders, dashboards, looks, isLoading, headers, showCreateButton, }) => {
    const [type] = (0, recoil_1.useRecoilState)(ReportViewToggle_1.recordTypeSwitcherState);
    const showFolders = type === 'all' || type === 'folders';
    const showDashboards = type === 'all' || type === 'dashboards';
    const showLooks = type === 'all' || type === 'looks';
    const hasContent = () => {
        return (!isLoading &&
            ((showFolders && folders.length !== 0) ||
                (showDashboards && dashboards.length !== 0) ||
                (showLooks && looks.length !== 0)));
    };
    if (!hasContent()) {
        return react_1.default.createElement(EmptyFolderState_1.default, { showCreateButton: showCreateButton });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !!showFolders && (react_1.default.createElement(ReportsTileView_1.default, { isLoading: isLoading, data: folders ?? [], title: "Folders", id: "folderTiles", headers: headers })),
        react_1.default.createElement("br", null),
        !!showDashboards && (react_1.default.createElement(ReportsTileView_1.default, { isLoading: isLoading, data: dashboards ?? [], title: "Dashboards", id: "dashboardTiles" })),
        react_1.default.createElement("br", null),
        !!showLooks && (react_1.default.createElement(ReportsTileView_1.default, { isLoading: isLoading, data: looks ?? [], title: "Looks", id: "lookTiles" }))));
};
exports.default = SubFolderTileView;
